import { capitalize } from 'lodash';
import React from 'react';
import type { SingleValueProps } from 'react-select';
import { components } from 'react-select';
import type { SortOption } from '../../CollapsedSelect';

const CustomSingleValue = (props: SingleValueProps<SortOption>) => {
  const {
    data: { categoryLabel },
  } = props;

  return (
    <components.SingleValue {...props}>
      {capitalize(categoryLabel)}
    </components.SingleValue>
  );
};

export default CustomSingleValue;
